import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.purchase;
import App from "./App/App.js";

export default {
  getList(params) {
    let options = { cid: App.Session.getCompanyID() };
    options = Object.assign(options, params);
    const attributes = ["cid", "name", "purchase", "warehouse", "status", "field",
      "startDate", "endDate"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/purchasing/list" + urlParams
    };
  },
  getDetails(id, params) {
    let options = {};
    options = Object.assign(options, params);
    const attributes = ["withpackagings", "withreceiving", "withreceivingcount"];
    const urlParams = App.Out.getParams(options, attributes);

    const cid = App.Session.getCompanyID();
    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/purchasing/" + cid + "/" + id + urlParams
    };
  },
  postPurchase(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/purchasing",
      data: data
    };
  },
  putPurchase(data) {
    return {
      method: App.Enum.Axios.Method.Put,
      url: apiEndpoint + "/api/v1/purchasing",
      data: data
    };
  },

  /* purchase item */

  getPurchaseItemDetails(purchaseItemId) {
    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/purchasingitem/" + purchaseItemId 
    };
  },
  postPurchaseItem(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/purchasingitem",
      data: data
    };
  }
}